<template>
  <div>
    <el-form :inline="true" :model="formInline" size="mini" class="user-search">
      <el-form-item>
        <el-cascader
          ref="cascader"
          size="mini"
          :placeholder="$t('deviceControl.operatorId')"
          filterable
          :options="operatorsTree"
          :show-all-levels="false"
          @change="handChangeOperator"
          :props="{ checkStrictly: true, expandTrigger: 'hover' }"
          v-model="operatorIds"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <el-form-item>
        <el-date-picker
          type="datetime"
          size="mini"
          v-model="formInline.t.beginTime"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('kai-shi-ri-qi')"
          style="width: 175px"
        ></el-date-picker>
        <span>{{ $t('deviceControl.to') }}</span>
        <el-date-picker
          type="datetime"
          size="mini"
          v-model="formInline.t.endTime"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('jie-shu-ri-qi')"
          style="width: 175px"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-input
          v-model="formInline.t.phone"
          size="mini"
          clearable
          :placeholder="$t('ke-hu-shou-ji-hao-0')"
          style="width: 160px"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="search">{{ $t('deviceControl.search') }}</el-button>
        <el-button
          v-if="checkPermission(['bee:order:report:reconciliationFlowExcel'])"
          type="primary"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="exportData"
        >{{ $t('excel-dao-chu') }}</el-button>
      </el-form-item>

      <el-table
        size="mini"
        :data="flowList"
        highlight-current-row
        v-loading="loading"
        border
        :element-loading-text="$t('paramMonitor.Loading')"
        style="width: 100%"
      >
        <af-table-column align="center" prop="orderNo" :label="$t('shang-hu-ding-dan-hao')"></af-table-column>
        <af-table-column align="center" prop="phone" :label="$t('ke-hu-shou-ji-hao-0')"></af-table-column>
        <af-table-column align="center" prop="thirdPartyId" :label="$t('jiao-yi-liu-shui-hao')"></af-table-column>
        <af-table-column align="center" prop="outRefundNo" :label="$t('tui-kuan-liu-shui-hao')"></af-table-column>
        <af-table-column align="center" prop="productCode" :label="$t('jiao-yi-lei-xing')"></af-table-column>
        <af-table-column align="center" prop="netReceiptAmount" :label="$t('shi-shou-jine-yuan')"></af-table-column>
        <af-table-column align="center" prop="createTime" :label="$t('jiao-yi-shi-jian')"></af-table-column>
      </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-form>
  </div>
</template>

<script>
import Pagination from '@/module/cardManage/component/Pagination.vue'
import report from '@/module/dataCenter/api/report.js'
import comApi from '@/common/api/commonApi.js'

export default {
  name: 'reconciliationFlowList',
  components: {
    Pagination
  },
  data() {
    return {
      operatorIds: [],
      operatorsTree: [],
      loading: false,
      exportLoading: false,
      flowList: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      formInline: {
        t: {
          operatorId: '',
          beginTime: null,
          endTime: null,
          phone: ''
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {
    this.getOperatorsTree()
    this.search()
  },
  methods: {
    getOperatorsTree() {
      comApi.getOperatorsTree(JSON.stringify({})).then((res) => {
        this.operatorsTree = res.data
      })
    },
    handChangeOperator(value) {
      this.formInline.t.operatorId = value && value.length > 0 ? value[value.length - 1] : ''
      this.$refs.cascader.dropDownVisible = false
    },
    callFather() {
      this.getData({
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        t: this.formInline.t
      })
    },
    resetSearchForm() {
      this.formInline.t = {
        operatorId: '',
        beginTime: null,
        endTime: null,
        phone: ''
      }
      this.operatorIds = []
      this.search()
    },
    search() {
      this.pageparm.currentPage = 1
      this.getData({
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        t: this.formInline.t
      })
    },
    getData(parameter) {
      if (!parameter.t.operatorId && !parameter.t.beginTime && !parameter.t.endTime && !parameter.t.phone) {
        this.$message({
          showClose: true,
          message: this.$t('qing-zhi-shao-xuan-ze-huo-shu-ru-yi-ge-cha-xia-tiao-jian'),
          type: 'error'
        })
        return
      }
      this.loading = true
      report.getReconciliationFlowList(JSON.stringify(parameter))
        .then((res) => {
          this.flowList = res.data.list
          this.pageparm.currentPage = res.data.pageNum
          this.pageparm.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    async exportData() {
      this.exportLoading = true
      let flag = false
      if (
        this.formInline.t.beginTime &&
        this.formInline.t.endTime &&
        this.formInline.t.beginTime !== '' &&
        this.formInline.t.endTime !== ''
      ) {
        const beginDate = new Date(this.formInline.t.beginTime.substring(0, 10))
        const endDate = new Date(this.formInline.t.endTime.substring(0, 10))
        const diffYear = endDate.getFullYear() - beginDate.getFullYear()
        const diffMonth = diffYear * 12 + endDate.getMonth() - beginDate.getMonth()
        const diffDay = endDate.getDate() - beginDate.getDate()
        if (diffMonth < 3 || (diffMonth === 3 && diffDay <= 0)) {
          flag = true
        }
      }
      if (!flag) {
        this.exportLoading = false
        this.$message.error(this.$t('qing-xuan-ze-3-ge-yue-zhi-nei-shu-ju-dao-chu'))
        return
      }
      const param = {
        operatorId: this.formInline.t.operatorId,
        beginTime: this.formInline.t.beginTime || '',
        endTime: this.formInline.t.endTime || '',
        phone: this.formInline.t.phone || ''
      }
      report.downloadReconciliationFlow(param).then((res) => {
        if (res) {
          this.downloadExcel(res, this.$t('dui-zhang-liu-shui'))
        }
        this.exportLoading = false
      }).catch(() => {
        this.exportLoading = false
      })
    },
    downloadExcel(res, name) {
      const blob = new Blob([res], {
        type: 'application/vnd.ms-excel;charset=utf-8'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = name + '.xlsx'
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/reconciliationFlow/list.vue